'use client';

import { INSIGHTS_PAGE_BUNDLES } from '@/utils/constants';

/**
 * Filter to only get records with the insights page bundles.
 */

export const insightsTypeFilters = INSIGHTS_PAGE_BUNDLES.map((bundle) => `type:${bundle}`).join(
  ' OR '
);
